// extracted by mini-css-extract-plugin
export default {"container":"GQXLAeJxx7AfBAX_3f4Q","challengeType":"M6xQRU8vQ2orgh1p0sPA"};